import React from 'react';
import styled from 'styled-components';

const PhysicianList = styled.ul`
    margin:1.25rem 0;
    padding:0;
    list-style-type:none;
`

const Physician = styled.li`
    display:flex;
    flex-direction:column;
    justify-content:center;
    border: 2px solid transparent;
    border-left:0;
    padding:1.5625rem 1.25rem;
    box-shadow:inset 0 0px 0 0 transparent;
    transition:box-shadow .3s ease-in-out, border-color .3s ease-in-out;

    &:hover {
        -webkit-box-shadow:inset 8px 0 0 0 #862633;
        box-shadow:inset 8px 0 0 0 #862633;
        border-color:rgba(134,38,51,0.19);
    }

    &:nth-child(even){
        background:#F7F7F7;
    }

    @media(min-width:48em){
        flex-direction:row;
        justify-content:flex-start;
        padding:2.1875rem 2.5rem;
    }
`

const PhysicianContent = styled.div`
    @media(min-width:48em){
        width:32%;
    }
`

const PhysicianMedia = styled.div`
    margin-bottom:.625rem;

    @media(min-width:48em){
        margin-bottom:0;
        flex-shrink:0;

        & + ${PhysicianContent} {
            margin-left:2rem;
        }
    }

    @media(min-width:80em){

        & + ${PhysicianContent} {
            margin-left:4rem;
        }
    }
`

const PhysicianImage = styled.img`
    max-width:5em;
    border-radius:5px;

    @media(min-width:48em){
        max-width:9.6875em;
    }
`

const PhysicianName = styled.h2`
    margin:0;
    font-size:1.125rem;
    line-height:1.666666;
    font-family:'Montserrat', sans-serif;
    font-weight:600;
    color:#3D3D3D;
`

const PhysicianService = styled.span`
    font-family:'Montserrat', sans-serif;
    font-size:1rem;
    font-weight:600;
    color:#3D3D3D;
`

const PhysicianServiceWrap = styled.div`
    word-break:break-word;

    & > ${PhysicianService} + ${PhysicianService}:before { content:", " }
`

const LocationsWrap = styled.div`
    margin-top:.75rem;

    @media(min-width:48em){
        margin-top:0;
        width:30%;
        padding:0 1rem;
    }
`

const LocationsWrapTitle = styled.h3`
    font-weight:700;
    font-size:1.125rem;
    color:#3D3D3D;
`

const Locations = styled.ul`
    margin:0;
    padding:0;
    list-style-type:none;
`

const Location = styled.li`
    margin-top:.6666rem;
    font-size:1.125rem;
    line-height:1.6666;
    color:#4F4F4F;

    &:first-child {
        margin-top:0;
    }
`

const LocationTitle = styled.h4`
    margin:0;
    font-weight:normal;
`

const LocationAddress = styled.div``

const PhysicianLink = styled.a`
    display:inline-block;
    width:100%;
    margin-top:1rem;

    @media(min-width:48em){
        width:auto;
       margin-left:auto; 
       margin-top:0;
       align-self:center;
    }
`

const PhysicianListing = (props) => {
    return (
        <>
            <PhysicianList className="physician-list">
                {props.physicians && props.physicians.map((p) => {
                    const HasImage = p.Image != null && p.Image.length > 0 ? true : false;
                    const HasLocations = p.Locations != null && p.Locations.length > 0 ? true : false;
                    const HasServices = p.ServicesList != null && p.ServicesList.length > 0 ? true : false;

                    return (
                        <Physician className="physician" key={p.Id}>
                            {HasImage ? 
                                <PhysicianMedia className="physician__media">
                                    <PhysicianImage className="physician__img" src={p.Image[0].Url} alt={p.Title}/>
                                </PhysicianMedia> 
                                : ""
                            }
                            
                            <PhysicianContent className="physician__content">
                                <PhysicianName className="physician__name">{p.Title}</PhysicianName>
                                {HasServices && 
                                    <PhysicianServiceWrap>
                                        {p.ServicesList.map((s) => {
                                            return(
                                                <PhysicianService key={s.Id}>{s.Title}</PhysicianService>
                                            )
                                        })}
                                    </PhysicianServiceWrap>
                                }
                            </PhysicianContent>

                            {HasLocations ? 
                                <LocationsWrap className="physician__locations-wrap">
                                    <LocationsWrapTitle className="physician__locations-title">Locations</LocationsWrapTitle>
                                    <Locations className="physician__locations">
                                        {p.Locations.map((l) => {
                                            const Title = l.DisplayTitle != null && l.DisplayTitle != "" ? l.DisplayTitle : l.Title
                                            return(
                                                <Location className="physician__location" key={l.Id}>
                                                    <LocationTitle className="physician__location-title">{Title}</LocationTitle>
                                                    <LocationAddress className="physician__location-address">
                                                        <div className="physician__location-street">{l.Address.Street}</div>
                                                        <span className="physician__location-city">{l.Address.City}</span> 
                                                        <span className="physician__location-state"> {l.Address.StateCode}</span> 
                                                        <span className="physician__location-state"> {l.Address.Zip}</span>
                                                    </LocationAddress>
                                                </Location>
                                            )
                                        })}
                                    </Locations>
                                </LocationsWrap>
                                : ""
                            }

                            <PhysicianLink href={`${props.detailUrl}/${p.UrlName}`} className="button button--outline">
                                More Details <span className="sr-only">about {p.Title}</span>
                            </PhysicianLink>
                        </Physician>
                    )
                })}
            </PhysicianList>
        </>
    )
}

export default PhysicianListing